// extracted by mini-css-extract-plugin
module.exports = {"openComments":"styles_openComments__nOCqD","list":"styles_list__2k-eb"};